import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

// React Icons
import { BsChevronDown, BsChevronUp, BsX } from "react-icons/bs";

// Languages
import { useTranslation } from "react-i18next";

// CSS
import "./creditcarddetails.css";

// Images
import doneImg from "../../../../../../assets/images/passangerData/done.png";

// Services
import {
  convertPrice,
  formatAgentWalletAmountIls,
  parseNumber,
} from "../../../../../../services/currencyService";

// Custom Functions
// import CustomAlertAgent from "../../../../../GeneralComponents/CustomAlertAgent/customalertagent";
import CustomLoading from "../../../../../GeneralComponents/CustomLoading/customloading";

// Icons
import visaIcon from "../../../../../../assets/images/payment/visa.png";
import visa1Icon from "../../../../../../assets/images/payment/visa1.png";
import MasterCardIcon from "../../../../../../assets/images/payment/card.png";
import { useCards } from "../../../../../../contexts/CardsContext";
import { quoteCardInstallment } from "../../../../../../pricing/paymentInstallmentsPricing";
import { buildLdsPaymentUrlAmounts } from "../../../../../../utils/orders/validateLdsPaymentLinkAmount";
import {
  isHubwayzCheckoutOrder,
  resolveHubwayzCardCharge,
} from "../../../../../../utils/payment/isHubwayzCheckoutOrder";
import { ApiReqBaseUrl } from "../../../../../../assets/GlobalVariables";
import axios from "axios";
import { resolveAgentPostSessionIdSync } from "../../../../../../services/fhpService";
import { Button, message, Popconfirm } from "antd";
import { useAppContext } from "../../../../../../contexts/AppContext";
import { removeLdsPaymentLink } from "../../../../../../services/fhpService";
import { getDelayedPayOrder } from "../../../../../../services/fhpService";
import { getUserInfo } from "../../../../../../services/localStorage";
import { isAdminUser } from "../../../../../../services/authService";
import {
  buildCreditCardDetailsViewerContextTrace,
  buildGimmonixOrderByIdViewerPayload,
  logCreditCardDetailsViewerContextTrace,
} from "../../../../../../utils/payment/resolvePaymentViewerContext";
import {
  buildGimmonixPaymentLinkSsotPayload,
  buildPaymentLinkHandlingFeeTraceFe,
  logPaymentLinkHandlingFeeTraceFe,
  logPaymentLinkSsotTraceFe,
  resolveGimmonixPaymentExchangeRateForLink,
  resolveHandlingFeeIncludedInTotalForPaymentLink,
} from "../../../../../../utils/payment/buildGimmonixPaymentLinkSsotPayload";
import { isFlightsNewProposalPackage } from "../../../../../../utils/dynamicPackageDisplayMode";
import { resolvePaymentOrderType } from "../../../../../../utils/orders/resolvePaymentOrderType";
import {
  trackMetaAddPaymentInfo,
} from "../../../../../../utils/metaPixel/metaPixelAnalytics";
import {
  resolveLdsSplitPaymentSlotLockUi,
  isLdsSplitPaymentSlotLocked,
} from "../../../../../../utils/orders/ldsSplitPaymentSlotLock";
import {
  findFirstUnlockedLdsCardIndex,
  resolveLdsLockedCardDisplayAmount,
  isLdsSplitPaymentCardEditable,
} from "../../../../../../utils/orders/ldsSplitPaymentCards";
import { resolveLdsPaymentSlotCapturedStrict } from "../../../../../../utils/orders/ldsSplitPaymentsSsot";
import { mergeOrderAfterPaymentLinkResponse } from "../../../../../../utils/orders/mergeOrderAfterPaymentLinkResponse";
import LdsPriceChangeConfirmModal from "../../../LdsPriceChangeConfirmModal";

function logHotelPaymentTotalRecalcTrace(payload) {
  if (typeof console !== "undefined" && typeof console.info === "function") {
    console.info("[HOTEL_PAYMENT_TOTAL_RECALC_TRACE]", payload);
  }
  try {
    // #region agent log
    fetch("http://127.0.0.1:7890/ingest/b0b67dfb-7306-4d13-82f5-46e25cc15ee5", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Debug-Session-Id": "e5c5ca",
      },
      body: JSON.stringify({
        sessionId: "e5c5ca",
        runId: "hotel-payment-total-recalc",
        hypothesisId: "T1,T2,T3,T4,T5",
        location:
          "src/Components/Agent/PaymentAgent/SplitPayment/subComponent/CreditCardDetails/creditcarddetails.jsx",
        message: "[HOTEL_PAYMENT_TOTAL_RECALC_TRACE]",
        data: payload,
        timestamp: Date.now(),
      }),
    }).catch(() => {});
    // #endregion
  } catch {
    /* ignore debug logging */
  }
}

function safeJsonObject(value) {
  if (!value) return {};
  if (typeof value === "object" && !Array.isArray(value)) return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  }
  return {};
}

function normalizeHotelPaymentText(value) {
  return String(value || "")
    .replace(/\s+/g, " ")
    .trim();
}

function pickHotelPaymentField(order, candidates) {
  for (const { path, value } of candidates) {
    const normalized = normalizeHotelPaymentText(value);
    if (normalized) return { value: normalized, sourceField: path };
  }
  return { value: null, sourceField: null };
}

function resolveHotelPaymentLinkHotelName(order) {
  const orderResponse = safeJsonObject(order?.order_response ?? order?.orderResponse);
  const packageSnapshot = safeJsonObject(order?.packageSnapshot ?? order?.package_snapshot);
  const hotel = safeJsonObject(order?.hotel);
  const orderResponseHotel = safeJsonObject(orderResponse?.hotel);
  const reservationHotel = safeJsonObject(orderResponse?.reservation?.hotel);
  const packageSnapshotHotel = safeJsonObject(packageSnapshot?.hotel);

  return pickHotelPaymentField(order, [
    { path: "order.hotelname", value: order?.hotelname },
    { path: "order.hotelName", value: order?.hotelName },
    { path: "order.hotel.name", value: hotel?.name },
    { path: "order.hotel.hotelName", value: hotel?.hotelName },
    { path: "order.order_response.hotelName", value: orderResponse?.hotelName },
    { path: "order.order_response.hotel.hotelName", value: orderResponseHotel?.hotelName },
    { path: "order.order_response.hotel.name", value: orderResponseHotel?.name },
    {
      path: "order.order_response.reservation.hotel.hotelName",
      value: reservationHotel?.hotelName,
    },
    { path: "order.packageSnapshot.hotel.name", value: packageSnapshotHotel?.name },
    { path: "order.packageSnapshot.hotel.hotelName", value: packageSnapshotHotel?.hotelName },
  ]);
}

function resolveHotelPaymentDisplayOrderNumber(order, routeOrderId) {
  const resolved = pickHotelPaymentField(order, [
    { path: "order.hr_order_number", value: order?.hr_order_number },
    { path: "order.hrOrderNumber", value: order?.hrOrderNumber },
    { path: "order.booking_ref", value: order?.booking_ref },
    { path: "order.bookingRef", value: order?.bookingRef },
    { path: "order.orderid", value: order?.orderid },
    { path: "order.order_id", value: order?.order_id },
    { path: "routeOrderId", value: routeOrderId },
  ]).value;
  if (!resolved || resolved === "-1" || resolved === "newOrder") return "בהמתנה";
  return /^HR-/i.test(resolved) ? resolved : `HR-${resolved}`;
}

function getHotelPaymentOrderFields(order) {
  const orderResponse = safeJsonObject(order?.order_response ?? order?.orderResponse);
  const packageSnapshot = safeJsonObject(order?.packageSnapshot ?? order?.package_snapshot);
  return {
    hotelname: order?.hotelname ?? null,
    hotelName: order?.hotelName ?? null,
    hotel: order?.hotel ?? null,
    order_response_hotelName: orderResponse?.hotelName ?? null,
    order_response_reservation_hotelName:
      orderResponse?.reservation?.hotel?.hotelName ?? null,
    packageSnapshotHotel: packageSnapshot?.hotel ?? null,
  };
}

function resolveHotelPaymentTotalIlsFromOrder(order) {
  const pricingSnapshot = safeJsonObject(order?.pricingSnapshot ?? order?.pricing_snapshot);
  const selectedPricingSnapshot = safeJsonObject(
    order?.selectedPriceSnapshot?.pricingSnapshot
  );
  const ourPrice = safeJsonObject(order?.ourPrice ?? order?.ourprice);
  const candidates = [
    pricingSnapshot?.totalWithCreditCardIls,
    pricingSnapshot?.totalIls,
    selectedPricingSnapshot?.totalWithCreditCardIls,
    selectedPricingSnapshot?.totalIls,
    ourPrice?.priceWithCreditCardFee,
    ourPrice?.priceWithHandleFee,
    order?.pricetotal,
    order?.totalprice,
    order?.bookingSsotIls,
  ];
  for (const candidate of candidates) {
    const value = Number(candidate);
    if (Number.isFinite(value) && value > 0) return Math.ceil(value);
  }
  return null;
}

function logHotelPaymentLinkItemTrace(payload) {
  if (typeof console !== "undefined" && typeof console.info === "function") {
    console.info("[HOTEL_PAYMENT_LINK_ITEM_TRACE]", payload);
  }
}

function logHotelHypAmountFinalTrace(payload) {
  if (typeof console !== "undefined" && typeof console.info === "function") {
    console.info("[HOTEL_HYP_AMOUNT_FINAL_TRACE]", payload);
  }
}

function logHotelPaymentDeleteTrace(payload) {
  if (typeof console !== "undefined" && typeof console.info === "function") {
    console.info("[HOTEL_PAYMENT_DELETE_TRACE]", payload);
  }
}

function getPaymentLinkUrl(paymentLink) {
  return (
    paymentLink?.paymentUrl ||
    paymentLink?.url ||
    paymentLink?.payment_url ||
    (paymentLink && typeof paymentLink === "object" ? paymentLink.payment_url : null)
  );
}

function countPaymentEntries(order) {
  const raw = order?.payments;
  if (Array.isArray(raw)) return raw.length;
  if (typeof raw === "string" && raw.trim()) {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.length : 0;
    } catch {
      return 0;
    }
  }
  return 0;
}

function resolveLdsPaymentRouteContext(orderReqData, orderId, isLdsPackageOrder = false) {
  const resolvedDealType = orderReqData?.deal_type || orderReqData?.dealtype;
  const resolvedOrderType = resolvePaymentOrderType(
    orderId || orderReqData?.id || null
  );
  const hasCruiseInfo = !!(orderReqData?.cruiseInfo || orderReqData?.cruise);
  const isCruiseOrder =
    orderReqData?.deal_type === "Cruise" || hasCruiseInfo;
  const isLdsOrder =
    !isCruiseOrder &&
    (Boolean(isLdsPackageOrder) ||
      resolvedOrderType.isUuidOrder ||
      resolvedDealType === "FlightsHotel" ||
      resolvedDealType === "OrganizedTour");

  return {
    resolvedDealType,
    resolvedOrderType,
    isCruiseOrder,
    isLdsOrder,
  };
}

function shouldUseDynamicPaymentUrl({
  dynamicOrderId,
  orderReqData,
  currentOrderId,
  location,
}) {
  if (dynamicOrderId) return true;
  if (isFlightsNewProposalPackage(orderReqData)) return true;
  return false;
}

function selectPaymentUrlEndpoint({
  dynamicOrderId,
  isCruiseOrder,
  isLdsOrder,
  orderReqData,
  currentOrderId,
  location,
}) {
  if (
    shouldUseDynamicPaymentUrl({
      dynamicOrderId,
      orderReqData,
      currentOrderId,
      location,
    })
  ) {
    return "/getDynamicPaymentUrl";
  }
  if (isCruiseOrder) return "/getCruisePaymentUrl";
  if (isLdsOrder) return "/getLDSPaymentUrl";
  return "/getGimmonixPaymentUrl";
}

function logLdsPaymentEndpointSelectionTrace(payload) {
  if (!import.meta.env?.DEV) return;
  // eslint-disable-next-line no-console
  console.info("[LDS_PAYMENT_ENDPOINT_SELECTION_TRACE]", payload);
}

function LdsSplitCardLockedExpandedPanel({ slotLockUi }) {
  if (!slotLockUi?.locked) return null;
  return (
    <div
      className="payment-card-details lds-split-card-locked-expanded lg:tw-w-full lg:tw-py-[12px] lg:tw-px-[24px] tw-flex tw-flex-col tw-gap-[8px]"
      aria-label="כרטיס תשלום נעול"
    >
      <div className="lds-split-card-locked-panel lds-split-card-locked-panel--expanded">
        <span className="lds-split-card-lock-badge">{slotLockUi.badgeLabel}</span>
        <div className="lds-split-card-locked-amount">
          סכום:{" "}
          <strong>
            ₪{Number(slotLockUi.capturedIls || 0).toLocaleString("he-IL")}
          </strong>
        </div>
      </div>
    </div>
  );
}

const CreditCardDetails = ({
  cardNumber,
  setOrderReqData,
  setDynamicOrder,
  paymentLink,
  handlingFee = 0,
  priceToPay,
  paymentLinksTotalToPay,
  cardIndex,
  isActiveCard = false,
  getOrderData,
  orderReqData, // Add orderReqData to check if it's a cruise order
  orderId, // Order ID from props (for cruise orders that don't have it in URL)
  isLdsPackageOrder = false,
  ldsBlockNewCreditLinks = false,
  ldsNoNewPaymentLinks = false,
  paymentExchangeRate = 0,
  bookingExchangeRate = 0,
  blockHotelPaymentUntilRepriceConfirmed = false,
  repriceHotelBaseIls = null,
  paymentRepriceConfirmed = false,
  isPublicCustomer = false,
  rejectedUnconvertedAmount = null,
}) => {
  const { t } = useTranslation();
  const payCtaLabel = isPublicCustomer
    ? "המשך לתשלום מאובטח"
    : t("paymentagent.create-pay-link");
  const { currentOrderId: currentOrderIdFromParams, dynamicOrderId } = useParams();
  const location = useLocation();
  // Use orderId from props if available (for cruise orders), otherwise from URL params
  const currentOrderId = orderId || currentOrderIdFromParams;
  const { interestTable } = useAppContext();

  const [submitLoading, setSubmitLoading] = useState(false);
  const [expandCard, setExpandCard] = useState(false);
  const [ldsPriceChangePayload, setLdsPriceChangePayload] = useState(null);
  const [ldsPriceChangeOpen, setLdsPriceChangeOpen] = useState(false);
  const [ldsPriceChangeConfirming, setLdsPriceChangeConfirming] = useState(false);
  const [ldsPriceChangeRequestBody, setLdsPriceChangeRequestBody] = useState(null);
  const { cards, updateCards, activeCardIndex, setActiveCardIndex } = useCards();
  const [nop, setNop] = useState(1);
  const hubwayzCheckout = isHubwayzCheckoutOrder(orderReqData);
  const hubwayzQuote = hubwayzCheckout
    ? quoteCardInstallment({
        principalIls: cards[cardIndex]?.amount,
        numberOfPayments: nop,
        interestTable,
      })
    : null;
  const currentCard = cards[cardIndex] || {
    numberofpayments: 1,
    amount: 0,
    amountWithInterest: 0,
    paid: false,
  };

  // Keep local select state in sync when CardsContext rebuilds numberofpayments
  // (e.g. after J5 / merge of agent prefs) — avoids dropdown showing 1 while fee text uses 3.
  useEffect(() => {
    const nextNop = Math.max(
      1,
      Math.floor(Number(currentCard?.numberofpayments)) || 1
    );
    setNop(nextNop);
  }, [currentCard?.numberofpayments, cardIndex]);

  const paymentSlot = useMemo(() => {
    if (paymentLink && typeof paymentLink === "object") return paymentLink;
    const payments = orderReqData?.payments;
    if (Array.isArray(payments) && payments[cardIndex] != null) {
      return payments[cardIndex];
    }
    return null;
  }, [paymentLink, orderReqData?.payments, cardIndex]);

  const ldsRouteCtx = useMemo(
    () =>
      resolveLdsPaymentRouteContext(
        orderReqData,
        currentOrderId,
        isLdsPackageOrder
      ),
    [orderReqData, currentOrderId, isLdsPackageOrder]
  );

  const isLdsSplitFlow = isLdsPackageOrder || ldsRouteCtx.isLdsOrder;

  const slotLockUi = useMemo(() => {
    if (!isLdsSplitFlow) {
      return { locked: false, badgeLabel: null, capturedIls: 0, isJ5: false };
    }
    return resolveLdsSplitPaymentSlotLockUi(
      paymentSlot,
      orderReqData,
      cardIndex
    );
  }, [isLdsSplitFlow, paymentSlot, orderReqData, cardIndex]);

  const isCardLocked =
    isLdsSplitFlow &&
    (slotLockUi.locked ||
      currentCard?.ldsSlotLocked === true ||
      isLdsSplitPaymentSlotLocked(paymentSlot, orderReqData, cardIndex));

  const lockedDisplayAmount = useMemo(() => {
    if (!isCardLocked) return null;
    return resolveLdsLockedCardDisplayAmount(
      paymentSlot,
      orderReqData,
      cardIndex
    );
  }, [isCardLocked, paymentSlot, orderReqData, cardIndex]);

  const isEditableCard =
    !isLdsSplitFlow ||
    isLdsSplitPaymentCardEditable(
      currentCard,
      paymentSlot,
      orderReqData,
      cardIndex
    );
  const slotCapturedAmount = useMemo(() => {
    if (!paymentSlot) return 0;
    return resolveLdsPaymentSlotCapturedStrict(
      paymentSlot,
      orderReqData,
      cardIndex
    );
  }, [paymentSlot, orderReqData, cardIndex]);

  const showSlotPaidAmount =
    isLdsSplitFlow &&
    (isCardLocked || slotCapturedAmount > 0 || currentCard?.paid);
  const blockNewCreditForSlot =
    isLdsSplitFlow &&
    (ldsNoNewPaymentLinks ||
      (ldsBlockNewCreditLinks && !isCardLocked && !paymentLink));
  const blockPaymentLinkCreation =
    blockNewCreditForSlot ||
    ldsNoNewPaymentLinks ||
    blockHotelPaymentUntilRepriceConfirmed;
  const amountInputDisabled =
    !isEditableCard ||
    currentCard?.paid ||
    isCardLocked ||
    Boolean(paymentLink) ||
    blockPaymentLinkCreation;
  const installmentsDisabled =
    !isEditableCard ||
    isCardLocked ||
    Boolean(paymentLink) ||
    blockPaymentLinkCreation;

  const [paymentLinkOpen, setPaymentLinkOpen] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);

  // Expand active card; locked slots stay collapsed unless user opens read-only
  useEffect(() => {
    if (isLdsSplitFlow) {
      setExpandCard(isActiveCard);
      return;
    }
    if (cardNumber === 1) setExpandCard(true);
  }, [isLdsSplitFlow, isActiveCard, cardNumber]);

  useEffect(() => {
    if (isLdsSplitFlow) return;
    if (!paymentSlot || isCardLocked) return;

    const thisCardTmp = { ...cards[cardIndex] };
    if (thisCardTmp?.ldsSlotLocked) return;

    thisCardTmp.numberofpayments = Number(paymentSlot.tash);
    thisCardTmp.amount = Number(paymentSlot.actualAmount);
    thisCardTmp.paid = paymentSlot.paid;
    const cardsTmp = [...cards];
    cardsTmp[cardIndex] = thisCardTmp;
    updateCards(cardsTmp);
    setNop(thisCardTmp.numberofpayments);
  }, [
    isLdsSplitFlow,
    paymentSlot?.tash,
    paymentSlot?.actualAmount,
    paymentSlot?.paid,
    cardIndex,
    isCardLocked,
  ]);

  // --- Functions
  const cardExpandor = () => {
    const next = !expandCard;
    if (
      isLdsSplitFlow &&
      next &&
      isEditableCard &&
      typeof setActiveCardIndex === "function"
    ) {
      setActiveCardIndex(cardIndex);
    }
    setExpandCard(next);
  };

  // Mark and un mark inputs
  const handleMarkEdit = (e) => {
    e.target?.classList.add("ci-input-editing");
  };

  const handleUnMarkEdit = (e) => {
    e.target?.classList.remove("ci-input-editing");
  };

  // Save changes for inputs
  const handleInputChange = (e) => {
    if (isCardLocked || !isEditableCard) return;
    let { name, value } = e.target;
    let newCardAmount = null;
    if (name === "amount") {
      newCardAmount = parseFloat(value);
      const otherCards = cards.reduce((sum, card, index) => {
        if (index === cardNumber - 1 || card?.paid) return sum;
        const cardAmount = Number(card?.amount) || 0;
        return sum + (cardAmount > 0 ? cardAmount : 0);
      }, 0);
      const balanceCap = Number(priceToPay) || 0;
      if (
        newCardAmount < 0 ||
        (balanceCap > 0 && newCardAmount + otherCards > balanceCap + 0.001)
      ) {
        return false;
      }
    }

    // Change caret color to default when the user starts typing
    if (value.length > 0) {
      e.target.style.caretColor = "auto";
    } else {
      e.target.style.caretColor = "transparent";
    }

    if (name === "cardnumber") {
      // Make spacing
      value = formatCreditCardNumber(value);
    }

    if (name === "expdate") {
      // Make automatic '/'
      if (value.length === 2 && value.indexOf("/") === -1) {
        value += "/";
      }
    }

    const updatedCards = [...cards];
    const updatedCard = {
      ...cards[cardNumber - 1],
      [name]: newCardAmount ?? value,
      ...(name === "amount" ? { principalTouched: true } : {}),
    };
    updatedCards[cardNumber - 1] = updatedCard;

    updateCards(updatedCards);
  };

  const formatCreditCardNumber = (value) => {
    const regex = /(\d{1,4})/g;
    const parts = value.match(regex);

    if (parts) {
      const formattedValue = parts.join(" ");

      return formattedValue;
    }
  };

  const handlePaymentsChange = (e) => {
    if (isCardLocked || !isEditableCard) return;
    if (paymentLink) return;
    const newPaymentsNumber = e.target.value;
    let tempCards = JSON.parse(JSON.stringify(cards));
    const tmpCurCard = tempCards[cardNumber - 1];
    tmpCurCard.numberofpayments = newPaymentsNumber;
    setNop(newPaymentsNumber);
    updateCards(tempCards);
  };

  const handlePayment = async (e) => {
    e.preventDefault();
    if (isCardLocked || !isEditableCard) {
      message.warning("התשלום בכרטיס זה כבר התקבל");
      return;
    }
    if (isLdsSplitFlow && cardIndex !== activeCardIndex) {
      const unlocked = findFirstUnlockedLdsCardIndex(cards, orderReqData);
      if (unlocked >= 0 && typeof setActiveCardIndex === "function") {
        setActiveCardIndex(unlocked);
      }
      message.warning("יש לבצע תשלום בכרטיס הפעיל");
      return;
    }
    if (blockNewCreditForSlot || ldsNoNewPaymentLinks) {
      message.warning(
        ldsNoNewPaymentLinks
          ? "ההזמנה שולמה במלואה — לא ניתן ליצור קישור תשלום נוסף"
          : "היתרה נסגרת בהעברה בנקאית — לא ניתן ליצור קישור תשלום בכרטיס"
      );
      return;
    }
    if (blockHotelPaymentUntilRepriceConfirmed) {
      message.warning("יש לאשר את עדכון השער לפני יצירת קישור תשלום");
      return;
    }
    if (currentCard.amount > 0) {
      setSubmitLoading(true);
      
      const orderIdToSend = dynamicOrderId || currentOrderId;
      const routeCtx = resolveLdsPaymentRouteContext(
        orderReqData,
        orderIdToSend,
        isLdsPackageOrder
      );
      const { isCruiseOrder, isLdsOrder, resolvedDealType } = routeCtx;
      const useDynamicPaymentApi = shouldUseDynamicPaymentUrl({
        dynamicOrderId,
        orderReqData,
        currentOrderId,
        location,
      });
      const requestEndpoint = selectPaymentUrlEndpoint({
        dynamicOrderId,
        isCruiseOrder,
        isLdsOrder,
        orderReqData,
        currentOrderId,
        location,
      });

      logLdsPaymentEndpointSelectionTrace({
        orderId: orderIdToSend,
        deal_type: orderReqData?.deal_type ?? null,
        dealtype: orderReqData?.dealtype ?? null,
        resolvedDealType: resolvedDealType ?? null,
        isLdsOrder,
        useDynamicPaymentApi,
        selectedEndpoint: requestEndpoint,
        skippedLegacyGimmonixRequests: isLdsOrder,
      });
      
      const userInfo = getUserInfo();
      const isAdmin = isAdminUser();
      const viewerPayload = buildGimmonixOrderByIdViewerPayload(userInfo, isAdmin);
      
      // Prepare request body - identical to LDS request structure (like production)
      // This ensures consistency between LDS and Cruise payment flows
      let amountToSend = currentCard.numberofpayments > 1
        ? parseFloat(currentCard.amountWithInterest.toFixed(2))
        : parseFloat(currentCard.amount);
      let actualAmountToSend = parseFloat(currentCard.amount);
      let hubwayzPaymentLink = null;
      if (hubwayzCheckout && requestEndpoint === "/getGimmonixPaymentUrl") {
        const hubwayzCharge = resolveHubwayzCardCharge({
          card: { ...currentCard, numberofpayments: nop },
          cards,
          balanceIls: priceToPay,
          interestTable,
        });
        if (!hubwayzCharge.ok) {
          message.error(hubwayzCharge.error);
          setSubmitLoading(false);
          return;
        }
        hubwayzPaymentLink = hubwayzCharge;
        actualAmountToSend = hubwayzCharge.actualAmount;
        amountToSend = hubwayzCharge.amount;
      } else if (requestEndpoint === "/getGimmonixPaymentUrl" && Number(priceToPay) > 0) {
        actualAmountToSend = Math.ceil(Number(priceToPay));
        amountToSend = actualAmountToSend;
      } else if (requestEndpoint === "/getLDSPaymentUrl" && Number(currentCard.amount) > 0) {
        const built = buildLdsPaymentUrlAmounts({
          cardAmount: currentCard.amount,
          numberOfPayments: currentCard.numberofpayments,
          amountWithInterest: currentCard.amountWithInterest,
          payableIls: priceToPay,
          rejectedUnconvertedAmount,
        });
        if (!built.ok) {
          message.error(built.error);
          setSubmitLoading(false);
          return;
        }
        actualAmountToSend = built.actualAmount;
        amountToSend = built.amount;
      }
      logHotelPaymentTotalRecalcTrace({
        source: "CreditCardDetails.handlePayment",
        orderId: orderIdToSend,
        baseHotelPrice: null,
        handlingFee: Number(handlingFee || 0),
        installments: Number(currentCard.numberofpayments || 1),
        installmentsFee: Math.max(
          0,
          Number(currentCard.amountWithInterest || 0) - Number(currentCard.amount || 0)
        ),
        resolvedTotalIls: Number(priceToPay || 0),
        paymentLinkAmountIls: amountToSend,
        currentCardAmount: Number(currentCard.amount || 0),
        currentCardAmountWithInterest: Number(currentCard.amountWithInterest || 0),
        paymentLinksTotalToPay: Number(paymentLinksTotalToPay || 0),
      });
      
      // Build description for cruise orders (like LDS orders)
      let paymentDescription = null;
      if (isCruiseOrder && orderReqData) {
        const orderNumber = orderReqData.order_number || orderReqData.id;
        paymentDescription = `תשלום עבור הזמנת מנו ספנות ${orderNumber}`;
      } else if (isFlightsNewProposalPackage(orderReqData)) {
        const oid = orderReqData?.id || dynamicOrderId || currentOrderId;
        paymentDescription = `תשלום עבור הצעת טיסה (PROPOSAL) — הזמנה ${oid || ""}`;
      }
      
      if (!orderIdToSend) {
        console.error('[CreditCardDetails] ERROR: orderId is missing!', {
          dynamicOrderId,
          currentOrderId,
          orderReqData
        });
        message.error('שגיאה: מספר הזמנה חסר');
        setSubmitLoading(false);
        return;
      }
      
      if (!amountToSend || amountToSend <= 0) {
        console.error('[CreditCardDetails] ERROR: amount is invalid!', {
          amountToSend,
          currentCardAmount: currentCard.amount,
          amountWithInterest: currentCard.amountWithInterest
        });
        message.error('שגיאה: סכום התשלום לא תקין');
        setSubmitLoading(false);
        return;
      }

      let hotelPaymentItemName = null;
      let hotelPaymentIdSource = null;
      let gimmonixPaymentSsotPayload = null;
      if (requestEndpoint === "/getGimmonixPaymentUrl") {
        hotelPaymentIdSource =
          new URLSearchParams(location.search).get("idSource") ||
          "orders.id";
        logCreditCardDetailsViewerContextTrace(
          buildCreditCardDetailsViewerContextTrace({
            orderId: orderIdToSend,
            idSource: hotelPaymentIdSource,
            userInfo,
            isAdmin,
          })
        );
        const freshOrderRes = await getDelayedPayOrder({
          id: orderIdToSend,
          idSource: hotelPaymentIdSource,
          agentID: viewerPayload.agentID,
          isAdmin: viewerPayload.isAdmin,
        });
        const freshOrder =
          freshOrderRes?.data && typeof freshOrderRes.data === "object"
            ? freshOrderRes.data
            : safeJsonObject(freshOrderRes?.data);
        if (!freshOrder || freshOrder.status === "fail") {
          message.error("שגיאה בטעינת ההזמנה לפני יצירת קישור תשלום");
          setSubmitLoading(false);
          return;
        }

        const displayOrderNumber = resolveHotelPaymentDisplayOrderNumber(
          freshOrder,
          orderIdToSend
        );
        const freshHotel = resolveHotelPaymentLinkHotelName(freshOrder);
        const displayedHotel = resolveHotelPaymentLinkHotelName(orderReqData);
        const resolvedHotelName = freshHotel.value;
        hotelPaymentItemName =
          resolvedHotelName || `Hotel order ${displayOrderNumber}`;
        paymentDescription = hotelPaymentItemName;
        const freshOrderTotalIls = resolveHotelPaymentTotalIlsFromOrder(freshOrder);
        const pageTotalIls = Math.ceil(Number(priceToPay || 0));
        const handlingFeeIls = Math.max(0, Math.ceil(Number(handlingFee || 0)));
        const repricedHotelBase =
          Number(repriceHotelBaseIls || 0) > 0
            ? Math.ceil(Number(repriceHotelBaseIls))
            : null;
        const baseHotelPriceIls =
          repricedHotelBase != null
            ? repricedHotelBase
            : paymentRepriceConfirmed
              ? Math.max(0, pageTotalIls - handlingFeeIls)
              : freshOrderTotalIls && freshOrderTotalIls > 0
                ? Math.ceil(Number(freshOrderTotalIls))
                : Math.max(0, pageTotalIls - handlingFeeIls);
        let installmentFeeIls = hubwayzPaymentLink
          ? Number(hubwayzPaymentLink.interestIls) || 0
          : 0;
        if (!hubwayzPaymentLink && !hubwayzCheckout && cards.length === 1 && pageTotalIls > 0) {
          const interestMultiplier =
            Number(currentCard.amountWithInterest) > 0 && Number(currentCard.amount) > 0
              ? Number(currentCard.amountWithInterest) / Number(currentCard.amount)
              : 1;
          installmentFeeIls =
            Number(currentCard.numberofpayments || 1) > 1
              ? Math.max(0, pageTotalIls * interestMultiplier - pageTotalIls)
              : 0;
          const resolvedTotalIls = Number(
            (baseHotelPriceIls + handlingFeeIls + installmentFeeIls).toFixed(2)
          );
          const expectedNoInstallmentsTotal = baseHotelPriceIls + handlingFeeIls;
          amountToSend =
            Number(currentCard.numberofpayments || 1) > 1
              ? resolvedTotalIls
              : expectedNoInstallmentsTotal;
          actualAmountToSend = expectedNoInstallmentsTotal;
          logHotelHypAmountFinalTrace({
            orderId: orderIdToSend,
            baseHotelPriceIls,
            handlingFeeIls,
            installmentFeeIls,
            resolvedTotalIls: amountToSend,
            hypAmountSent: amountToSend,
            source: "hotel_payment_total_with_handling_fee",
          });
          if (Number(amountToSend) !== Number(resolvedTotalIls) && Number(currentCard.numberofpayments || 1) > 1) {
            message.error("HYP amount mismatch blocked");
            setSubmitLoading(false);
            return;
          }
          if (Number(currentCard.numberofpayments || 1) <= 1 && Number(amountToSend) !== Number(expectedNoInstallmentsTotal)) {
            message.error("HYP amount mismatch blocked");
            setSubmitLoading(false);
            return;
          }
        }

        const tracePayload = {
          routeOrderId: orderIdToSend,
          displayOrderNumber,
          resolvedHotelName,
          paymentItemName: hotelPaymentItemName,
          paymentAmountIls: amountToSend,
          freshOrderTotalIls,
          sourceField: freshHotel.sourceField || "fallback",
          orderHotelFields: getHotelPaymentOrderFields(freshOrder),
          localStorageIgnored: true,
        };
        logHotelPaymentLinkItemTrace(tracePayload);

        const normalizedDisplayedHotel = normalizeHotelPaymentText(displayedHotel.value)
          .toLowerCase();
        const normalizedPaymentItem = normalizeHotelPaymentText(hotelPaymentItemName)
          .toLowerCase();
        if (
          normalizedDisplayedHotel &&
          normalizedPaymentItem &&
          normalizedDisplayedHotel !== normalizedPaymentItem
        ) {
          console.error("Payment item mismatch blocked", {
            ...tracePayload,
            displayedHotelName: displayedHotel.value,
            displayedHotelSourceField: displayedHotel.sourceField,
          });
          message.error("Payment item mismatch blocked");
          setSubmitLoading(false);
          return;
        }

        const resolvedPaymentExchangeRate = resolveGimmonixPaymentExchangeRateForLink({
          paymentExchangeRate,
          bookingExchangeRate,
          freshOrder,
          orderReqData,
        });
        const handlingFeeIncludedInTotal = resolveHandlingFeeIncludedInTotalForPaymentLink({
          hotelBaseAmountIls: baseHotelPriceIls,
          handlingFeeIls,
          interestFeeIls: installmentFeeIls,
          amount: amountToSend,
          actualAmount: actualAmountToSend,
        });
        gimmonixPaymentSsotPayload = buildGimmonixPaymentLinkSsotPayload({
          baseHotelPriceIls,
          handlingFeeIls,
          interestFeeIls: installmentFeeIls,
          paymentExchangeRate: resolvedPaymentExchangeRate,
          handlingFeeIncludedInTotal,
        });
        logPaymentLinkHandlingFeeTraceFe(
          buildPaymentLinkHandlingFeeTraceFe({
            hotelBaseAmountIls: baseHotelPriceIls,
            handlingFeeIls,
            amount: amountToSend,
            actualAmount: actualAmountToSend,
            handlingFeeIncludedInTotal,
            interestFeeIls: installmentFeeIls,
          })
        );
        logPaymentLinkSsotTraceFe({
          orderId: orderIdToSend,
          expected_hotel_base_ils: baseHotelPriceIls,
          request_hotelBaseAmountIls: gimmonixPaymentSsotPayload.hotelBaseAmountIls,
          handling_fee_ils: gimmonixPaymentSsotPayload.handlingFeeIls,
          expected_total_ils:
            gimmonixPaymentSsotPayload.hotelBaseAmountIls +
            gimmonixPaymentSsotPayload.handlingFeeIls +
            gimmonixPaymentSsotPayload.interestFeeIls,
          request_actualAmount: actualAmountToSend,
          delta:
            Number(actualAmountToSend) -
            (gimmonixPaymentSsotPayload.hotelBaseAmountIls +
              gimmonixPaymentSsotPayload.handlingFeeIls +
              gimmonixPaymentSsotPayload.interestFeeIls),
          sourceResolver: "CreditCardDetails.buildGimmonixPaymentLinkSsotPayload",
          status:
            Number(actualAmountToSend) ===
            gimmonixPaymentSsotPayload.hotelBaseAmountIls +
              gimmonixPaymentSsotPayload.handlingFeeIls +
              gimmonixPaymentSsotPayload.interestFeeIls
              ? "PASS"
              : "PENDING_BE",
          paymentExchangeRate: gimmonixPaymentSsotPayload.paymentExchangeRate ?? null,
        });
      }
      
      const requestBody = {
        amount: amountToSend,
        actualAmount: actualAmountToSend,
        currency: "ILS",
        orderId: orderIdToSend,
        ...(hotelPaymentIdSource ? { idSource: hotelPaymentIdSource } : {}),
        tash: hubwayzPaymentLink ? hubwayzPaymentLink.tash : currentCard.numberofpayments,
        description: paymentDescription,
        ...(hotelPaymentItemName
          ? {
              itemName: hotelPaymentItemName,
              productName: hotelPaymentItemName,
              hotelName: hotelPaymentItemName,
              orderDescription: hotelPaymentItemName,
            }
          : {}),
        ...(gimmonixPaymentSsotPayload || {}),
        agentId: viewerPayload.agentID,
        isAdmin: viewerPayload.isAdmin,
        ...(hubwayzCheckout ? { cardIndex } : {}),
      };
      if (hubwayzPaymentLink) {
        requestBody.amount = hubwayzPaymentLink.amount;
        requestBody.actualAmount = hubwayzPaymentLink.actualAmount;
        requestBody.tash = hubwayzPaymentLink.tash;
        requestBody.interestFeeIls = hubwayzPaymentLink.interestIls;
      }
      const applyPaymentLinkSuccess = (data) => {
            if (data.status === "ok" && data.order) {
              // Normalize payment structure - ensure both url and paymentUrl are available
              if (data.order.payments && Array.isArray(data.order.payments)) {
                // Check if any payment URL is invalid (returnUrl instead of payment gateway)
                let hasInvalidUrl = false;
                data.order.payments = data.order.payments.map(payment => {
                  // For cruise orders, paymentUrl might be the field, but we need url for compatibility
                  // For regular orders, url is the field
                  // Also check payment_url (from DB) for backward compatibility
                  const paymentUrl = payment.paymentUrl || payment.url || payment.payment_url;
                  
                  if (!paymentUrl) {
                    hasInvalidUrl = true;
                  }
                  
                  // Check if URL is from payment gateway (but don't fail if it's a valid URL format)
                  // Only warn if it's clearly not a payment gateway URL
                  if (paymentUrl && !paymentUrl.startsWith('http://') && !paymentUrl.startsWith('https://')) {
                    hasInvalidUrl = true;
                  }
                  
                  return {
                    ...payment,
                    url: paymentUrl, // Ensure url field exists
                    paymentUrl: paymentUrl, // Ensure paymentUrl field exists
                    payment_url: paymentUrl // Also set payment_url for consistency
                  };
                });
                
                // If there's an invalid URL, show error and don't continue
                if (hasInvalidUrl) {
                  message.error('שגיאה: קישור התשלום לא תקין. נא לבדוק את הגדרות ה-API של Yad Sarig.');
                  setSubmitLoading(false);
                  return false;
                }
              }
              
              if (!dynamicOrderId && !useDynamicPaymentApi) {
                setOrderReqData((prev) =>
                  mergeOrderAfterPaymentLinkResponse(prev ?? orderReqData, data.order)
                );
              } else {
                if (setDynamicOrder) {
                  setDynamicOrder((prev) =>
                    mergeOrderAfterPaymentLinkResponse(prev ?? orderReqData, data.order)
                  );
                }
                setOrderReqData((prev) =>
                  mergeOrderAfterPaymentLinkResponse(prev ?? orderReqData, data.order)
                );
              }
              message.success("קישור לתשלום נוצר בהצלחה");
              trackMetaAddPaymentInfo(
                data.order ?? orderReqData,
                orderIdToSend,
                { value: amountToSend }
              );
              return true;
            }
            return false;
      };

      axios
        .post(ApiReqBaseUrl + requestEndpoint, requestBody, {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
          validateStatus: () => true,
        })
        .then((res) => {
          const raw = res.data;
          const data =
            raw && typeof raw === "object"
              ? JSON.parse(JSON.stringify(raw))
              : raw;
          if (applyPaymentLinkSuccess(data)) {
            return;
          }
          // P2-bis Staging: real base-fare change only (never TOKEN_REFRESH).
          if (
            requestEndpoint === "/getLDSPaymentUrl" &&
            data?.code === "PRICE_CHANGED" &&
            data?.price_change_token &&
            data?.reason !== "OFFER_TOKEN_REFRESH" &&
            (res.status === 409 || res.status === 200)
          ) {
            setLdsPriceChangePayload(data);
            setLdsPriceChangeRequestBody(requestBody);
            setLdsPriceChangeOpen(true);
            return;
          }
          // TOKEN_REFRESH is handled silently on BE (offer promote + allow).
          // If it ever surfaces as an error, do not show the price modal.
          if (
            requestEndpoint === "/getLDSPaymentUrl" &&
            (data?.code === "TOKEN_REFRESH" ||
              data?.reason === "OFFER_TOKEN_REFRESH")
          ) {
            if (applyPaymentLinkSuccess(data)) {
              return;
            }
            message.error(
              data?.message_he ||
                data?.message ||
                "רענון מזהה ההצעה נכשל. נסו שוב."
            );
            return;
          }
          if (
            requestEndpoint === "/getLDSPaymentUrl" &&
            (res.status === 409 || data?.code === "UNVERIFIABLE")
          ) {
            message.error(
              data?.message_he ||
                data?.message ||
                data?.error ||
                "לא ניתן לאמת את מחיר החבילה. התשלום נחסם."
            );
            return;
          }
          message.error(data.message || data.error || "שגיאה ביצירת קישור לתשלום");
        })
        .catch((err) => {
          message.error("שגיאה ביצירת קישור לתשלום - בעיית רשת");
          setSubmitLoading(false);
        })
        .finally(() => {
          setSubmitLoading(false);
        });
    } else {
      message.warning("לא ניתן ליצור קישור תשלום - סכום לא תקין");
    }
  };

  const handleLdsPriceChangeConfirm = async () => {
    if (!ldsPriceChangePayload?.price_change_token || !ldsPriceChangeRequestBody) {
      setLdsPriceChangeOpen(false);
      return;
    }
    setLdsPriceChangeConfirming(true);
    try {
      const acceptBody = {
        ...ldsPriceChangeRequestBody,
        price_change_token: ldsPriceChangePayload.price_change_token,
        accepted_base_fare:
          ldsPriceChangePayload.accepted_base_fare_required ??
          ldsPriceChangePayload.base_fare_new,
      };
      // Prefer remaining_new for amount after sell reprice when available.
      if (
        ldsPriceChangePayload.remaining_new != null &&
        Number(ldsPriceChangePayload.remaining_new) > 0
      ) {
        const rem = Math.ceil(Number(ldsPriceChangePayload.remaining_new));
        acceptBody.actualAmount = rem;
        if (Number(acceptBody.tash || 1) <= 1) {
          acceptBody.amount = rem;
        }
      }
      const res = await axios.post(ApiReqBaseUrl + "/getLDSPaymentUrl", acceptBody, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        validateStatus: () => true,
      });
      const data = res.data && typeof res.data === "object" ? res.data : {};
      if (data.status === "ok" && data.order) {
        const useDyn = shouldUseDynamicPaymentUrl({
          dynamicOrderId,
          orderReqData,
          currentOrderId,
          location,
        });
        if (!dynamicOrderId && !useDyn) {
          setOrderReqData((prev) =>
            mergeOrderAfterPaymentLinkResponse(prev ?? orderReqData, data.order)
          );
        } else {
          if (setDynamicOrder) {
            setDynamicOrder((prev) =>
              mergeOrderAfterPaymentLinkResponse(prev ?? orderReqData, data.order)
            );
          }
          setOrderReqData((prev) =>
            mergeOrderAfterPaymentLinkResponse(prev ?? orderReqData, data.order)
          );
        }
        message.success("המחיר אושר ונוצר קישור לתשלום");
        setLdsPriceChangeOpen(false);
        setLdsPriceChangePayload(null);
        setLdsPriceChangeRequestBody(null);
        return;
      }
      if (
        data?.code === "PRICE_CHANGED" &&
        data?.price_change_token &&
        data?.reason !== "OFFER_TOKEN_REFRESH"
      ) {
        setLdsPriceChangePayload(data);
        message.warning(
          data.message_he || "המחיר השתנה שוב. יש לאשר את המחיר העדכני."
        );
        return;
      }
      message.error(
        data?.message_he || data?.message || data?.error || "אישור המחיר נכשל"
      );
    } catch {
      message.error("שגיאת רשת באישור שינוי המחיר");
    } finally {
      setLdsPriceChangeConfirming(false);
    }
  };

  const handleDeletePayment = async () => {
    const orderIdToDelete = dynamicOrderId || currentOrderId;
    const paymentUrlForDelete = getPaymentLinkUrl(paymentLink);
    const paymentId = paymentLink?.id ?? null;
    const paymentsBefore = countPaymentEntries(orderReqData);

    logHotelPaymentDeleteTrace({
      orderId: orderIdToDelete,
      paymentId,
      action: "start",
      responseStatus: null,
      paymentsBefore,
      paymentsAfter: null,
    });

    setIsRequesting(true);
    try {
      const isCruiseOrder =
        orderReqData?.deal_type === "Cruise" || orderReqData?.cruiseInfo;
      const rawDealType = String(
        orderReqData?.deal_type || orderReqData?.dealtype || ""
      ).trim();
      const isOrderIdUuid =
        typeof orderIdToDelete === "string" &&
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
          orderIdToDelete
        );
      const ldsDealTypes = new Set([
        "FlightsHotel",
        "OrganizedTour",
        "Dynamic",
        "VacationPackage",
        "Package",
        "Flights",
        "Flight",
      ]);
      const isLdsOrder =
        !isCruiseOrder &&
        (!!dynamicOrderId || isOrderIdUuid || ldsDealTypes.has(rawDealType));
      const useDynamicPaymentApi = shouldUseDynamicPaymentUrl({
        dynamicOrderId,
        orderReqData,
        currentOrderId,
        location,
      });

      let deleteEndpoint = "/removeHotelPaymentUrl";
      let deleteBody = {
        paymentLink: paymentUrlForDelete,
        orderId: orderIdToDelete,
      };

      if (isCruiseOrder) {
        deleteEndpoint = "/removeCruisePaymentUrl";
        if (paymentId) {
          deleteBody = {
            paymentId:
              typeof paymentId === "string" ? parseInt(paymentId, 10) : paymentId,
            orderId: orderIdToDelete,
          };
        } else if (paymentUrlForDelete) {
          deleteBody = {
            paymentLink: paymentUrlForDelete,
            orderId: orderIdToDelete,
          };
        } else {
          deleteBody = { orderId: orderIdToDelete };
        }
      } else if (useDynamicPaymentApi) {
        // Dynamic package / flights_new — UUID on dynamic_packages (same as getDynamicPaymentUrl).
        deleteEndpoint = "/removeDynamicPaymentUrl";
      } else if (isLdsOrder) {
        deleteEndpoint = "/removeLDSPaymentUrl";
      }

      const res = await axios.post(ApiReqBaseUrl + deleteEndpoint, deleteBody, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        validateStatus: () => true,
      });

      if (res.status < 200 || res.status >= 300 || res.data?.status === "fail") {
        const messageText =
          res.data?.message || res.data?.error || "שגיאה במחיקת תשלום";
        logHotelPaymentDeleteTrace({
          orderId: orderIdToDelete,
          paymentId,
          action: "error",
          responseStatus: res.status,
          paymentsBefore,
          paymentsAfter: countPaymentEntries(res.data?.order || res.data),
        });
        message.error(messageText);
        return;
      }

      const updatedOrder = res.data?.order || res.data;
      if (updatedOrder && typeof updatedOrder === "object") {
        if (dynamicOrderId || useDynamicPaymentApi) {
          if (setDynamicOrder) {
            setDynamicOrder((prev) =>
              mergeOrderAfterPaymentLinkResponse(prev ?? orderReqData, updatedOrder)
            );
          }
          setOrderReqData((prev) =>
            mergeOrderAfterPaymentLinkResponse(prev ?? orderReqData, updatedOrder)
          );
        } else {
          setOrderReqData((prev) =>
            mergeOrderAfterPaymentLinkResponse(prev ?? orderReqData, updatedOrder)
          );
        }
      }

      setPaymentLinkOpen(false);
      await getOrderData();
      logHotelPaymentDeleteTrace({
        orderId: orderIdToDelete,
        paymentId,
        action: "success",
        responseStatus: res.status,
        paymentsBefore,
        paymentsAfter: countPaymentEntries(updatedOrder),
      });
      message.success("תשלום נמחק בהצלחה");
    } catch (error) {
      console.error("[CreditCardDetails] Error deleting payment:", error);
      logHotelPaymentDeleteTrace({
        orderId: orderIdToDelete,
        paymentId,
        action: "error",
        responseStatus: null,
        paymentsBefore,
        paymentsAfter: null,
      });
      message.error("שגיאה במחיקת תשלום");
    } finally {
      setIsRequesting(false);
      logHotelPaymentDeleteTrace({
        orderId: orderIdToDelete,
        paymentId,
        action: "finally",
        responseStatus: null,
        paymentsBefore,
        paymentsAfter: null,
      });
    }
  };

  const renderHubwayzPaymentsFee = (quote) => {
    if (!quote?.ok) return null;
    const annualInterestRate = Number(quote.annualRate) || 0;
    return (
      <span style={{ color: "black", fontSize: 16 }}>
        {`שים לב, לתשלום תתווסף ריבית תשלומים בסך`}
        <span style={{ color: "red", margin: "0 5px", fontWeight: "bold" }}>
          {formatAgentWalletAmountIls(quote.paymentInterest)}
        </span>
        <div style={{ fontSize: 16, color: "grey" }}>
          {`(${formatAgentWalletAmountIls(quote.amountWithInterest)} = ${quote.numberOfPayments} חודשים * ${formatAgentWalletAmountIls(quote.perPaymentIls)})`}
        </div>
        {annualInterestRate > 0 && (
          <div style={{ fontSize: 16, color: "grey", marginTop: "4px" }}>
            {`משקף ריבית שנתית על סך ${annualInterestRate.toFixed(2)}%`}
          </div>
        )}
      </span>
    );
  };

  const renderPaymentsFee = () => {
    const { amount, numberofpayments } = currentCard;
    const grossIls = Number(currentCard.amountWithInterest);
    const interestIls = Number(currentCard.paymentInterest);
    if (!amount || !Number.isFinite(grossIls) || grossIls <= 0) {
      return null;
    }
    const perMonthIls =
      numberofpayments > 0 ? grossIls / Number(numberofpayments) : grossIls;

    // Get annual interest rate from interestTable
    const annualInterestRate = interestTable && interestTable[numberofpayments] 
      ? interestTable[numberofpayments] 
      : 0;
    
    return (
      <span style={{ color: "black", fontSize: 16 }}>
        {`שים לב, לתשלום תתווסף ריבית תשלומים בסך`}
        <span style={{ color: "red", margin: "0 5px", fontWeight: "bold" }}>
          {formatAgentWalletAmountIls(interestIls)}
        </span>
        <div style={{ fontSize: 16, color: "grey" }}>
          {`(${formatAgentWalletAmountIls(grossIls)} = ${numberofpayments} חודשים * ${formatAgentWalletAmountIls(perMonthIls)})`}
        </div>
        {annualInterestRate > 0 && (
          <div style={{ fontSize: 16, color: "grey", marginTop: "4px" }}>
            {`משקף ריבית שנתית על סך ${annualInterestRate.toFixed(2)}%`}
          </div>
        )}
      </span>
    );
  };

  // const iframeRef = useRef(null);

  // const handleIframeLoad = () => {
  //   if (iframeRef.current) {
  //     const iframeWindow = iframeRef.current.contentWindow;
  //     const currentUrl = iframeWindow.location.href;
  //     if (currentUrl.includesTaxes("payment-success")) {
  //       getOrderData();
  //     }
  //   }
  // };

  return (
    <>
      <LdsPriceChangeConfirmModal
        open={ldsPriceChangeOpen}
        payload={ldsPriceChangePayload}
        confirming={ldsPriceChangeConfirming}
        onConfirm={handleLdsPriceChangeConfirm}
        onCancel={() => {
          if (ldsPriceChangeConfirming) return;
          setLdsPriceChangeOpen(false);
          setLdsPriceChangePayload(null);
          setLdsPriceChangeRequestBody(null);
        }}
      />
      <div className={`splitPayment-wrapper${isCardLocked ? " splitPayment-wrapper--locked" : ""}`}>
        <div
          className="splitPayment-card-extand-wrapper"
          onClick={cardExpandor}
        >
          <div className="splitPayment-card-extand-item">
            <img className="splitPayment-card-extand-img" src={doneImg}></img>
            <span className="splitPayment-card-extand-title">
              {t("paymentagent.cc")}: {cardNumber}
              {isCardLocked ? (
                <span className="lds-split-card-lock-badge lds-split-card-lock-badge--title">
                  {slotLockUi.badgeLabel}
                </span>
              ) : null}
            </span>
          </div>

          <div className="credit-card-left-topay-wrapper">
            {isCardLocked ? (
              <span className="lds-split-card-lock-badge lds-split-card-lock-badge--header">
                {slotLockUi.badgeLabel}
              </span>
            ) : null}
            <div
              className="credit-card-left-topay"
              style={{
                opacity: showSlotPaidAmount || currentCard.paid ? "1" : "0",
              }}
            >
              <label>סה&quot;כ שולם:</label>
              <label>
                {showSlotPaidAmount
                  ? Number(
                      lockedDisplayAmount ??
                        slotLockUi.capturedIls ??
                        slotCapturedAmount ??
                        0
                    ).toFixed(2)
                  : currentCard.paid
                    ? currentCard.amount.toFixed(2)
                    : 0}
              </label>
            </div>

            <div className="splitPayment-card-extand-item">
              {!expandCard ? (
                <BsChevronDown></BsChevronDown>
              ) : (
                <BsChevronUp></BsChevronUp>
              )}
            </div>

            {paymentLinkOpen ? (
              <BsX
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();

                  setPaymentLinkOpen(false);
                }}
                style={{
                  rotate: "180deg",
                  height: "20px",
                  width: "20px",
                }}
              ></BsX>
            ) : null}
          </div>
        </div>

        {/* Card Shower */}
        {expandCard &&
          (isCardLocked ? (
            <LdsSplitCardLockedExpandedPanel slotLockUi={slotLockUi} />
          ) : paymentLinkOpen ? (
            <iframe
              // ref={iframeRef}
              title={`payment-link-${cardIndex}`}
              src={paymentLink?.paymentUrl || paymentLink?.url || paymentLink?.payment_url || 
                   (paymentLink && typeof paymentLink === 'object' ? paymentLink.payment_url : '')}
              style={{ width: "100%", height: "1000px" }}
              onLoad={async () => {
                await getOrderData();
                // After getting order data, check if payment was completed
                if (dynamicOrderId) {
                  const res = await axios.post(
                    ApiReqBaseUrl + `/getDynamicOrder`,
                    {
                      id: dynamicOrderId,
                      agentID: (() => {
                        const u = getUserInfo();
                        return u?.id || u?.agent_id || 0;
                      })(),
                    },
                    {
                      headers: {
                        "Content-Type": "application/json",
                      },
                      withCredentials: true,
                      validateStatus: () => true,
                    }
                  );
                  if (res.status >= 200 && res.status < 300) {
                    const orderData = res.data;
                    if (orderData.data) {
                      const allPayments = orderData.data.payments || [];
                      const paidPayments = allPayments.filter((p) => p.paid);
                      if (paidPayments.length > 0) {
                        const totalAmountPaid = paidPayments.reduce(
                          (sum, p) => sum + (parseFloat(p.amount) || 0),
                          0
                        );
                        const totalNumberOfPayments = paidPayments.reduce(
                          (sum, p) => sum + (parseInt(p.tash) || 1),
                          0
                        );
                        const numberOfCreditCards = paidPayments.length;

                        axios
                          .put(
                            ApiReqBaseUrl + `/orders/${dynamicOrderId}`,
                            {
                              totalAmountPaid: totalAmountPaid,
                              totalNumberOfPayments: totalNumberOfPayments,
                              numberOfCreditCards: numberOfCreditCards,
                            },
                            {
                              headers: {
                                "Content-Type": "application/json",
                              },
                              withCredentials: true,
                              validateStatus: () => true,
                            }
                          )
                          .then(async () => {
                            if (!dynamicOrderId) return;

                            try {
                              const priceResponse = await axios.get(
                                `${ApiReqBaseUrl}/orders/${dynamicOrderId}/price-calculations`,
                                {
                                  withCredentials: true,
                                  validateStatus: () => true,
                                }
                              );
                              if (
                                priceResponse.status >= 200 &&
                                priceResponse.status < 300
                              ) {
                                const priceData = priceResponse.data;
                                if (
                                  priceData.status === "success" &&
                                  priceData.data
                                ) {
                                  const totalPriceNow =
                                    priceData.data.now?.total_price || 0;
                                  const priceDifference = Math.abs(
                                    totalAmountPaid - totalPriceNow
                                  );

                                  if (priceDifference <= 2) {
                                    const agentEmail = getUserInfo()?.email;
                                    await axios.put(
                                      ApiReqBaseUrl +
                                        `/orders/${dynamicOrderId}`,
                                      {
                                        status: "paid",
                                        email: agentEmail,
                                        sumpaid: totalAmountPaid,
                                      },
                                      {
                                        headers: {
                                          "Content-Type": "application/json",
                                        },
                                        withCredentials: true,
                                        validateStatus: () => true,
                                      }
                                    );
                                  }
                                }
                              }
                            } catch (err) {
                              /* endpoint may be unavailable */
                            }
                          })
                          .catch((err) => {
                            console.error(
                              "Error updating order payment summary:",
                              err
                            );
                          });
                      }
                    }
                  }
                } else {
                  const iframeRouteCtx = resolveLdsPaymentRouteContext(
                    orderReqData,
                    currentOrderId,
                    isLdsPackageOrder
                  );
                  if (iframeRouteCtx.isLdsOrder) {
                    logLdsPaymentEndpointSelectionTrace({
                      orderId: currentOrderId,
                      deal_type: orderReqData?.deal_type ?? null,
                      dealtype: orderReqData?.dealtype ?? null,
                      resolvedDealType: iframeRouteCtx.resolvedDealType ?? null,
                      isLdsOrder: true,
                      selectedEndpoint: null,
                      skippedLegacyGimmonixRequests: true,
                    });
                    return;
                  }

                  const sid = resolveAgentPostSessionIdSync();
                  const res = await axios.post(
                    `${ApiReqBaseUrl}/orderByID`,
                    { id: currentOrderId, ...(sid ? { sessionID: sid } : {}) },
                    {
                      headers: {
                        "Content-Type": "application/json",
                      },
                      withCredentials: true,
                      validateStatus: () => true,
                    }
                  );
                  if (res.status >= 200 && res.status < 300) {
                    const orderData = res.data;
                    if (orderData.data) {
                      const allPayments = orderData.data.payments || [];
                      const paidPayments = allPayments.filter((p) => p.paid);
                      if (paidPayments.length > 0) {
                        const totalAmountPaid = paidPayments.reduce(
                          (sum, p) => sum + (parseFloat(p.amount) || 0),
                          0
                        );
                        const totalNumberOfPayments = paidPayments.reduce(
                          (sum, p) => sum + (parseInt(p.tash) || 1),
                          0
                        );
                        const numberOfCreditCards = paidPayments.length;

                        axios
                          .put(
                            ApiReqBaseUrl + `/orders/${currentOrderId}`,
                            {
                              totalAmountPaid: totalAmountPaid,
                              totalNumberOfPayments: totalNumberOfPayments,
                              numberOfCreditCards: numberOfCreditCards,
                            },
                            {
                              headers: {
                                "Content-Type": "application/json",
                              },
                              withCredentials: true,
                              validateStatus: () => true,
                            }
                          )
                          .then(async () => {
                            if (!currentOrderId) return;

                            try {
                              const priceResponse = await axios.get(
                                `${ApiReqBaseUrl}/orders/${currentOrderId}/price-calculations`,
                                {
                                  withCredentials: true,
                                  validateStatus: () => true,
                                }
                              );
                              if (
                                priceResponse.status >= 200 &&
                                priceResponse.status < 300
                              ) {
                                const priceData = priceResponse.data;
                                if (
                                  priceData.status === "success" &&
                                  priceData.data
                                ) {
                                  const totalPriceNow =
                                    priceData.data.now?.total_price || 0;
                                  const priceDifference = Math.abs(
                                    totalAmountPaid - totalPriceNow
                                  );

                                  if (priceDifference <= 2) {
                                    const agentEmail = getUserInfo()?.email;
                                    await axios.put(
                                      ApiReqBaseUrl +
                                        `/orders/${currentOrderId}`,
                                      {
                                        status: "paid",
                                        email: agentEmail,
                                        sumpaid: totalAmountPaid,
                                      },
                                      {
                                        headers: {
                                          "Content-Type": "application/json",
                                        },
                                        withCredentials: true,
                                        validateStatus: () => true,
                                      }
                                    );
                                  }
                                }
                              }
                            } catch (err) {
                              /* endpoint may be unavailable */
                            }
                          })
                          .catch((err) => {
                            console.error(
                              "Error updating order payment summary:",
                              err
                            );
                          });
                      }
                    }
                  }
                }
              }}
            ></iframe>
          ) : (
            <div className="payment-card-details lg:tw-w-full lg:tw-py-[12px] lg:tw-px-[24px] tw-flex tw-flex-col tw-gap-[8px]">
              {/* Card Cataloger */}
              <div className="splitPayment-card-displayer-item">
                <form
                  id={`card-number-${cardNumber}`}
                  onSubmit={handlePayment}
                  className="splitPayment-card"
                >
                  {/* Left to pay */}
                  {/* <div className="ci-ltp">
                    <label className="ci-ltp-title">
                      {t("paymentagent.lefttopay")}:
                    </label>
                    <label id="price-leftToPay" className="ci-ltp-value">
                      {convertPrice(parseFloat(priceToPay))}
                    </label>
                  </div> */}

                  {/* Amount & Num of payments */}
                  <div className="ci-a-nop">
                    <div
                      className="ci-a-nop-item"
                      style={{ display: "row", flexWrap: "nowrap" }}
                    >
                      {currentCard.numberofpayments > 0 ? (
                        <>
                          <label htmlFor={`price-amount-${cardNumber}`} className="sr-only">
                            {t("paymentagent.amount")}
                          </label>
                          <input
                            name="amount"
                            type="number"
                            id={`price-amount-${cardNumber}`}
                            className="payment-agent-input payment-agent-input-amount"
                            onChange={handleInputChange}
                            onFocus={handleMarkEdit}
                            onBlur={handleUnMarkEdit}
                            placeholder={t("paymentagent.amount")}
                            value={currentCard.amount != null ? parseNumber(currentCard.amount) || '' : ''}
                            disabled={amountInputDisabled}
                            required
                            autoComplete="off"
                            aria-label={t("paymentagent.amount")}
                          ></input>
                        </>
                      ) : null}
                    </div>

                    <div className="ci-a-nop-item-nop">
                      <label htmlFor={`splitPayment-card-amount-input-${cardNumber}`} className="ci-a-nop-item-label">
                        {t("paymentagent.numberofpayments")}:
                      </label>
                      <select
                        className="splitPayment-card-amount-input"
                        name={`splitPayment-card-amount-input-${cardNumber}`}
                        id={`splitPayment-card-amount-input-${cardNumber}`}
                        onChange={handlePaymentsChange}
                        disabled={installmentsDisabled}
                        value={nop}
                        autoComplete="off"
                        aria-label={t("paymentagent.numberofpayments")}
                      >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                      </select>
                    </div>
                  </div>
                  {Number(nop) > 1 && hubwayzCheckout && hubwayzQuote?.rateMissing ? (
                    <div style={{ color: "red", fontSize: 16, marginRight: 10 }}>
                      {hubwayzQuote.error}
                    </div>
                  ) : Number(nop) > 1 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        whiteSpace: "nowrap",
                        alignItems: "center",
                        fontSize: 20,
                        marginRight: 10,
                      }}
                    >
                      {"תשלום סופי:"}
                      <span style={{ fontWeight: "bold", marginRight: 5 }} translate="no">
                        {formatAgentWalletAmountIls(
                          hubwayzCheckout ? hubwayzQuote?.amountWithInterest : currentCard.amountWithInterest
                        )}
                      </span>
                    </div>
                  ) : null}
                  {Number(nop) > 1 && !(hubwayzCheckout && hubwayzQuote?.rateMissing) ? (
                    <div className="ci-a-nop">
                      {hubwayzCheckout ? renderHubwayzPaymentsFee(hubwayzQuote) : renderPaymentsFee()}
                    </div>
                  ) : null}

                  {/* Submit button */}
                  <div className="ci-submit">
                    {paymentLink ? (
                      !paymentLink.paid ? (
                        <div
                          className="buttons"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            flexWrap: "wrap",
                          }}
                        >
                          <Button
                            type="dashed"
                            onClick={() => {
                              // copy payment url - check all possible field names
                              const paymentUrl = paymentLink?.paymentUrl || paymentLink?.url || paymentLink?.payment_url || 
                                                (paymentLink && typeof paymentLink === 'object' ? paymentLink.payment_url : null);
                              if (paymentUrl) {
                                navigator.clipboard.writeText(paymentUrl);
                                message.success("קישור לתשלום הועתק בהצלחה");
                              } else {
                                message.error("קישור תשלום לא זמין");
                                console.error('[CreditCardDetails] Payment URL missing for copy:', {
                                  paymentLink,
                                  paymentLinkKeys: paymentLink ? Object.keys(paymentLink) : []
                                });
                              }
                            }}
                            children="העתק קישור לתשלום"
                          />
                          <Button
                            type="primary"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              
                              // Open payment url in new tab
                              // Check all possible field names for payment URL
                              const paymentUrl = paymentLink?.paymentUrl || paymentLink?.url || paymentLink?.payment_url || 
                                                (paymentLink && typeof paymentLink === 'object' ? paymentLink.payment_url : null);
                              
                              if (!paymentUrl) {
                                message.error("קישור תשלום לא זמין");
                                return;
                              }
                              
                              // Validate URL format
                              let validUrl;
                              try {
                                validUrl = new URL(paymentUrl);
                              } catch (error) {
                                message.error("קישור תשלום לא תקין");
                                return;
                              }
                              
                              // Check if URL points to home page (this shouldn't happen)
                              const urlPath = validUrl.pathname.toLowerCase();
                              if (urlPath === '/' || urlPath.includes('/home') || urlPath.includes('/dashboard/home')) {
                                message.error("קישור תשלום לא תקין - מפנה לעמוד הבית");
                                return;
                              }
                              
                              // Open in new window/tab instead of iframe to avoid redirect issues
                              const paymentWindow = window.open(paymentUrl, '_blank', 'noopener,noreferrer');
                              
                              if (!paymentWindow) {
                                // If popup blocked, fall back to iframe
                                setPaymentLinkOpen(true);
                                trackMetaAddPaymentInfo(
                                  orderReqData,
                                  dynamicOrderId || currentOrderId,
                                  {
                                    value:
                                      currentCard.numberofpayments > 1
                                        ? currentCard.amountWithInterest
                                        : currentCard.amount,
                                  }
                                );
                              } else {
                                // Successfully opened in new window
                                message.info("חלון תשלום נפתח בחלון חדש");
                                trackMetaAddPaymentInfo(
                                  orderReqData,
                                  dynamicOrderId || currentOrderId,
                                  {
                                    value:
                                      currentCard.numberofpayments > 1
                                        ? currentCard.amountWithInterest
                                        : currentCard.amount,
                                  }
                                );
                              }
                            }}
                            children="שלם עכשיו"
                            disabled={paymentLink.paid}
                          />
                          <Popconfirm
                            title="האם אתה בטוח שברצונך למחוק את התשלום?"
                            onConfirm={handleDeletePayment}
                            okText="כן"
                            cancelText="לא"
                            getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
                            overlayClassName="delete-payment-popconfirm"
                          >
                            <Button
                              type="primary"
                              danger
                              children="מחק תשלום"
                              loading={isRequesting}
                            />
                          </Popconfirm>
                        </div>
                      ) : (
                        <label
                          style={{
                            color: "green",
                            fontSize: 20,
                            fontWeight: "bold",
                          }}
                        >
                          {t("paymentagent.payment-done")}
                        </label>
                      )
                    ) : !submitLoading ? (
                      blockPaymentLinkCreation && !blockHotelPaymentUntilRepriceConfirmed ? (
                        <span className="lds-settlement-credit-blocked-hint">
                          {ldsNoNewPaymentLinks
                            ? "ההזמנה שולמה במלואה"
                            : "היתרה נסגרת בהעברה בנקאית"}
                        </span>
                      ) : (
                      <button
                        type="submit"
                        className="credit-card-checkout-btn"
                        disabled={
                          ldsNoNewPaymentLinks ||
                          blockHotelPaymentUntilRepriceConfirmed ||
                          Boolean(hubwayzCheckout && hubwayzQuote?.rateMissing)
                        }
                      >
                        {payCtaLabel}
                      </button>
                      )
                    ) : (
                      <CustomLoading
                        label={
                          String(orderReqData?.dealtype || "").trim() === "FlightsHotel"
                            ? "מאמת מחיר מול הספק ויוצר קישור תשלום…"
                            : payCtaLabel
                        }
                      />
                    )}
                  </div>

                  {/* Pics */}
                  <div className="ci-pics">
                    <div className="payment-agent-icons-wrapper">
                      <img
                        src={MasterCardIcon}
                        className="payment-agent-icons"
                        alt="Master Card Icon"
                      ></img>
                      <img
                        src={visa1Icon}
                        className="payment-agent-icons"
                        alt="visa icon"
                      ></img>
                      <img
                        src={visaIcon}
                        className="payment-agent-icons"
                        alt="visa icon"
                      ></img>
                    </div>

                    <label className="ci-pics-title">תשלום מאובטח</label>
                  </div>

                  {/* Error / Success messege */}
                  <div className="ci-messeger">
                    <label
                      id={`messege-${cardNumber}-suc`}
                      className="ci-messeger-success"
                    >
                      כרטיס האשראי עבר בהצלחה
                    </label>
                    <label
                      id={`messege-${cardNumber}-err`}
                      className="ci-messeger-error"
                    >
                      כרטיס האשראי לא עבר
                    </label>
                  </div>
                </form>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default CreditCardDetails;
